const getServerUrl = (): string => {
  return `${process.env.REACT_APP_BACKEND_ENDPOINT}`;
};

export { getServerUrl };
